import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";
import { api } from "../../resources/api";

export interface IFrontendLogData {
  type: string;
  data: {
    component?: string;
    timestamp?: string;
    userAgent?: string;
    url?: string;
    [key: string]: any;
  };
}

export const sendFrontendLog = createAsyncThunk<void, IFrontendLogData>(
  "frontendLog/sendFrontendLog",
  async (logData) => {
    try {
      await axiosInstance.post(api.frontendLog.CREATE_LOG, logData);
    } catch (error: any) {
    }
  }
);

